package com.mxpainting

object Strings {
    val pageTitle = mapOf(
        Language.ENGLISH to "MX Painting - Professional House Painters in Victoria, BC",
        Language.SPANISH to "MX Painting - Pintores Profesionales de Casas en Victoria, BC"
    )

    val pageDescription = mapOf(
        Language.ENGLISH to "MX Painting offers top-quality residential and commercial painting services in Victoria, BC. Professional painters for interiors, exteriors, and cabinets.",
        Language.SPANISH to "MX Painting ofrece servicios de pintura residencial y comercial de alta calidad en Victoria, BC. Pintores profesionales para interiores, exteriores y gabinetes."
    )

    val pageKeywords = mapOf(
        Language.ENGLISH to "painters Victoria BC, house painters Victoria, residential painting Victoria, commercial painters Victoria BC, interior painters Victoria, exterior house painting Victoria",
        Language.SPANISH to "pintores Victoria BC, pintores de casas Victoria, pintura residencial Victoria, pintores comerciales Victoria BC, pintura de interiores Victoria, pintura exterior Victoria"
    )

    val brandName = "MX Painting"
    val address = "Victoria, BC. Canada | 250.884.9487 | MXPAINTING@GMAIL.COM"
    
    val home = mapOf(
        Language.ENGLISH to "Home",
        Language.SPANISH to "Inicio"
    )
    val services = mapOf(
        Language.ENGLISH to "Services",
        Language.SPANISH to "Servicios"
    )

    val contact = mapOf(
        Language.ENGLISH to "Contact",
        Language.SPANISH to "Contacto"
    )

    val navGetAQuote = mapOf(
        Language.ENGLISH to "Get A Quote",
        Language.SPANISH to "Obtener Cotización"
    )

    //Contact page

    val contactText = mapOf(
        Language.ENGLISH to "Get in touch with the top-rated house painters in Victoria, BC. We offer free estimates for all residential and commercial projects.",
        Language.SPANISH to "Póngase en contacto con los mejores pintores de casas en Victoria, BC. Ofrecemos cotizaciones gratuitas para todos los proyectos residenciales y comerciales."
    )

    val contactOfficeCardHeader = mapOf(
        Language.ENGLISH to "Office",
        Language.SPANISH to "Oficina"
    )

    val contactOfficeCardDescription = mapOf(
        Language.ENGLISH to "Victoria, BC, Canada",
        Language.SPANISH to "Victoria, BC, Canada"
    )

    val contactPhoneCardHeader = mapOf(
        Language.ENGLISH to "Phone",
        Language.SPANISH to "Teléfono"
    )

    val contactPhoneCardDescription = mapOf(
        Language.ENGLISH to "+250 884 9487",
        Language.SPANISH to "+250 884 9487"
    )

    val contactEmailCardHeader = mapOf(
        Language.ENGLISH to "Email",
        Language.SPANISH to "Correo"
    )

    val contactEmailCardDescription = mapOf(
        Language.ENGLISH to "mxpainting@gmail.com",
        Language.SPANISH to "mxpainting@gmail.com"
    )

    val contactOurLocation = mapOf(
        Language.ENGLISH to "Our Location",
        Language.SPANISH to "Nuestra Ubicación"
    )

    val contactSendUsAMessage = mapOf(
        Language.ENGLISH to "Send Us A Message",
        Language.SPANISH to "Envíenos Un Mensaje"
    )

    val contactName = mapOf(
        Language.ENGLISH to "Name",
        Language.SPANISH to "Nombre"
    )

    val contactEmail = mapOf(
        Language.ENGLISH to "Email",
        Language.SPANISH to "Correo"
    )

    val contactPhone = mapOf(
        Language.ENGLISH to "Phone",
        Language.SPANISH to "Teléfono"
    )

    val contactMessage = mapOf(
        Language.ENGLISH to "Message",
        Language.SPANISH to "Mensaje"
    )

    val contactSend = mapOf(
        Language.ENGLISH to "Send",
        Language.SPANISH to "Enviar"
    )

    val contactSending = mapOf(
        Language.ENGLISH to "Sending...",
        Language.SPANISH to "Enviando..."
    )

    val contactMessageSent = mapOf(
        Language.ENGLISH to "Message sent successfully!",
        Language.SPANISH to "¡Mensaje enviado con éxito!"
    )

    val contactMessageError = mapOf(
        Language.ENGLISH to "Error sending message. Please call / email us while we resolve the issue",
        Language.SPANISH to "Error al enviar el mensaje. Por favor, llámanos o envíanos un correo mientras resolvemos el problema"
    )

    val contactFormError = mapOf(
        Language.ENGLISH to "Error in contact form. Please call / email us while we resolve the issue",
        Language.SPANISH to "Error en el formulario de contacto. Por favor, llámanos o envíanos un correo mientras resolvemos el problema"
    )

    // Services page
    val servicesHeader = mapOf(
        Language.ENGLISH to "Professional Painting Services in Victoria",
        Language.SPANISH to "Servicios de Pintura Profesionales en Victoria"
    )

    val servicesIntro = mapOf(
        Language.ENGLISH to "MX Painting is proud to offer the most reliable and high-quality painting services in Victoria, BC. Our expertise covers a wide range of needs, ensuring that whether you're looking for house painters in Victoria for a small interior refresh or a large commercial exterior project, we have you covered.",
        Language.SPANISH to "MX Painting se enorgullece de ofrecer los servicios de pintura más confiables y de alta calidad en Victoria, BC. Nuestra experiencia cubre una amplia gama de necesidades, asegurando que ya sea que busque pintores de casas en Victoria para un pequeño retoque interior o un gran proyecto comercial exterior, lo tenemos cubierto."
    )

    val servicesInteriorTitle = mapOf(
        Language.ENGLISH to "Interior Painting:",
        Language.SPANISH to "Pintura de Interiores:"
    )

    val servicesInteriorDesc = mapOf(
        Language.ENGLISH to " From living rooms to kitchens, we provide flawless finishes with premium paints.",
        Language.SPANISH to " Desde salas hasta cocinas, brindamos acabados impecables con pinturas de primera calidad."
    )

    val servicesExteriorTitle = mapOf(
        Language.ENGLISH to "Exterior Painting:",
        Language.SPANISH to "Pintura de Exteriores:"
    )

    val servicesExteriorDesc = mapOf(
        Language.ENGLISH to " Protect your home from Victoria's coastal climate with durable, weather-resistant coatings.",
        Language.SPANISH to " Proteja su hogar del clima costero de Victoria con recubrimientos duraderos y resistentes a la intemperie."
    )

    val servicesCabinetTitle = mapOf(
        Language.ENGLISH to "Cabinet Refinishing:",
        Language.SPANISH to "Restauración de Gabinetes:"
    )

    val servicesCabinetDesc = mapOf(
        Language.ENGLISH to " Specialized kitchen cabinet painting to modernize your home without the cost of a full remodel.",
        Language.SPANISH to " Pintura especializada de gabinetes de cocina para modernizar su hogar sin el costo de una remodelación completa."
    )

    val servicesCommercialTitle = mapOf(
        Language.ENGLISH to "Commercial Painting:",
        Language.SPANISH to "Pintura Comercial:"
    )

    val servicesCommercialDesc = mapOf(
        Language.ENGLISH to " Professional services for Victoria businesses, including offices, retail spaces, and strata buildings.",
        Language.SPANISH to " Servicios profesionales para negocios en Victoria, incluyendo oficinas, espacios comerciales y edificios de condominios (strata)."
    )

    val servicesAreaPart1 = mapOf(
        Language.ENGLISH to "We serve all of Greater Victoria, including ",
        Language.SPANISH to "Servimos a todo el Gran Victoria, incluyendo "
    )

    val servicesAreaBold = mapOf(
        Language.ENGLISH to "Saanich, Oak Bay, Esquimalt, Langford, and Sidney",
        Language.SPANISH to "Saanich, Oak Bay, Esquimalt, Langford y Sidney"
    )

    val servicesAreaPart2 = mapOf(
        Language.ENGLISH to ". Our commitment to excellence and attention to detail makes us the preferred choice for homeowners and developers alike.",
        Language.SPANISH to ". Nuestro compromiso con la excelencia y la atención al detalle nos convierte en la opción preferida tanto para propietarios como para promotores."
    )

    val servicesFreeEstimate = mapOf(
        Language.ENGLISH to "Get Your Free Estimate Today",
        Language.SPANISH to "Obtenga su Cotización Gratuita Hoy"
    )

    val warrantyHeader = mapOf(
        Language.ENGLISH to "Warranty",
        Language.SPANISH to "Garantía"
    )

    val warrantyText = mapOf(
        Language.ENGLISH to """
Mx Painting, Inc. warrants the painting of interior and exterior painted surfaces for a period of (2) years, per the specific contracted scope of work, and will repair newly painted areas if peeling, blistering, flaking, or coating separation occurs.  The Painting Warranty is limited to workmanship.  Both our Interior Paint Warranty and our Exterior Paint Warranty cover painting defects, but they do not cover areas of fading and/or damage due to normal wear and tear, abuse, weather, or accidental damaging occurrences.

If a defect in workmanship appears within 2 years from the date of project completion and is reported to MX Painting, Inc., Our company will inspect the affected areas and perform the necessary repairs.

MX Painting, Inc. began in 2006 and has developed an outstanding reputation and client base by consistently providing high quality painting services and providing excellence in customer service during and after project completion.

Mx Painting specializes in Residential, Commercial and Industrial Painting,  Drywall – Interior Repair and Power Washing.
""".trimIndent(),
        Language.SPANISH to """
MX Painting, Inc. garantiza la pintura de superficies interiores y exteriores por un período de (2) años, según el alcance del trabajo contratado, y reparará las áreas recién pintadas si se produce desprendimiento, ampollamiento, descamación o separación del recubrimiento. La garantía de pintura se limita a la mano de obra. Tanto nuestra Garantía de Pintura Interior como nuestra Garantía de Pintura Exterior cubren defectos de pintura, pero no cubren áreas de decoloración y/o daños debidos al desgaste normal, abuso, clima o daños accidentales.

Si aparece un defecto en la mano de obra dentro de los 2 años posteriores a la fecha de finalización del proyecto y se informa a MX Painting, Inc., nuestra empresa inspeccionará las áreas afectadas y realizará las reparaciones necesarias.

MX Painting, Inc. comenzó en 2006 y ha desarrollado una reputación y una base de clientes sobresalientes al brindar constantemente servicios de pintura de alta calidad y excelencia en el servicio al cliente durante y después de la finalización del proyecto.

MX Painting se especializa en Pintura Residencial, Comercial e Industrial, reparación de interiores de paneles de yeso (Drywall) y lavado a presión (Power Washing).
""".trimIndent()
    )

    // Services Carousel

    val servicesCarouselHeader = mapOf (
        Language.ENGLISH to "Our Services",
        Language.SPANISH to "Nuestros Servicios"
    )

    val servicesCarouselSubHeader = mapOf (
        Language.ENGLISH to "Professional Painting Solutions",
        Language.SPANISH to "Soluciones de Pintura Profesional"
    )

    val servicesCarouselIntPaintTitle = mapOf(
        Language.ENGLISH to "Interior Painting",
        Language.SPANISH to "Pintura de Interiores"
    )

    val servicesCarouselIntPaintDesc = mapOf(
        Language.ENGLISH to "Transform your home with our professional interior painting. We handle everything from walls and ceilings to cabinets and trim.",
        Language.SPANISH to "Transforma tu hogar con nustro servicio de pintura de interiores. Podemos manejar todo, desde paredes y techos hasta gabinetes y molduras. "
    )

    val servicesCarouselExtPaintTitle = mapOf(
        Language.ENGLISH to "Exterior Painting",
        Language.SPANISH to "Pintura de Exteriores"
    )

    val servicesCarouselExtPaintDesc = mapOf(
        Language.ENGLISH to "Protect and beautify your property's exterior. We specialize in painting siding, decks, fences, and more.",
        Language.SPANISH to "Protege y embellece el exterior de tu propiedad. Nos especializamos en pintura de exteriores, cubiertas, cercas y más."
    )

    val servicesCarouselPowerWashTitle = mapOf(
        Language.ENGLISH to "Power Washing",
        Language.SPANISH to "Power Washing"
    )

    val servicesCarouselPowerWashDesc = mapOf(
        Language.ENGLISH to "Remove dirt, mold, and grime from your surfaces to prepare for painting or simply to refresh your home's appearance.",
        Language.SPANISH to "Elimina la suciedad, el moho y la mugre de tus superficies para prepararlas para pintar o simplemente para refrescar la apariencia de tu hogar."
    )

    val servicesCarouselRepairsTitle = mapOf(
        Language.ENGLISH to "Repairs & Prep",
        Language.SPANISH to "Reparaciones y Preparación"
    )

    val servicesCarouselRepairsDesc = mapOf(
        Language.ENGLISH to "A great paint job starts with great prep. We provide surface repairs, sanding, and priming to ensure a long-lasting finish.",
        Language.SPANISH to "Un gran trabajo de pintura comienza con una gran preparación. Brindamos reparaciones de superficies, lijado y sellado para garantizar un acabado duradero."
    )

    val servicesCarouselGetAQuote = mapOf(
        Language.ENGLISH to "Get A Free Quote",
        Language.SPANISH to "Obtener Cotización Gratuita"
    )


    // Home page
    val homeHeroHeader = mapOf(
        Language.ENGLISH to "Professional House Painters in Victoria, BC — MX Painting",
        Language.SPANISH to "Pintores Profesionales de Casas en Victoria, BC — MX Painting"
    )

    val homeIntroP1Part1 = mapOf(
        Language.ENGLISH to "Are you looking for the best ",
        Language.SPANISH to "¿Estás buscando a los mejores "
    )

    val homeIntroP1Bold = mapOf(
        Language.ENGLISH to "house painters in Victoria, BC",
        Language.SPANISH to "pintores de casas en Victoria, BC"
    )

    val homeIntroP1Part2 = mapOf(
        Language.ENGLISH to "? Whether you need interior painting for your home or exterior painting for your business, MX Painting provides top-tier results that transform your space. We specialize in residential and commercial painting projects across the Greater Victoria area, including Saanich, Oak Bay, Langford, and Esquimalt.",
        Language.SPANISH to "? Ya sea que necesites pintura interior para tu hogar o pintura exterior para tu negocio, MX Painting ofrece resultados de primer nivel que transforman tu espacio. Nos especializamos en proyectos de pintura residencial y comercial en toda el área de Victoria, incluidos Saanich, Oak Bay, Langford y Esquimalt."
    )

    val homeIntroP2 = mapOf(
        Language.ENGLISH to "Our team of skilled Victoria painters is dedicated to quality and customer satisfaction. We only use the best materials and premium paints to ensure a beautiful, long-lasting finish for your home or office. From kitchen cabinet painting to full exterior transformations, we handle every project with precision and care.",
        Language.SPANISH to "Nuestro equipo de pintores calificados en Victoria está dedicado a la calidad y la satisfacción del cliente. Solo usamos los mejores materiales y pinturas de primera calidad para garantizar un acabado hermoso y duradero para tu hogar u oficina. Desde la pintura de gabinetes de cocina hasta transformaciones exteriores completas, manejamos cada proyecto con precisión y cuidado."
    )

    val homeIntroP3Part1 = mapOf(
        Language.ENGLISH to "Contact us today for a ",
        Language.SPANISH to "Contáctanos hoy para una "
    )

    val homeIntroP3Bold = mapOf(
        Language.ENGLISH to "Free Painting Estimate in Victoria",
        Language.SPANISH to "Cotización Gratuita de Pintura en Victoria"
    )

    val homeIntroP3Part2 = mapOf(
        Language.ENGLISH to ". Let us help you bring new life to your property with professional color consultations and expert craftsmanship.",
        Language.SPANISH to ". Permítenos ayudarte a darle nueva vida a tu propiedad con consultas profesionales de color y artesanía experta."
    )

    val homeCommunityHeader = mapOf(
        Language.ENGLISH to "Trusted by the Community",
        Language.SPANISH to "Con la confianza de la comunidad"
    )

    val homeCommunityVerified = mapOf(
        Language.ENGLISH to "Verified contractor",
        Language.SPANISH to "Contratista verificado"
    )

    val homeCommunityFollow = mapOf(
        Language.ENGLISH to "Follow our work",
        Language.SPANISH to "Sigue nuestro trabajo"
    )

    val homeCommunityGallery = mapOf(
        Language.ENGLISH to "Browse our gallery",
        Language.SPANISH to "Explora nuestra galería"
    )

    val homeCommunityReviews = mapOf(
        Language.ENGLISH to "Read our reviews",
        Language.SPANISH to "Lee nuestras reseñas"
    )

    val homeOfferHeader = mapOf(
        Language.ENGLISH to "What We Offer",
        Language.SPANISH to "Lo que ofrecemos"
    )

    val homeOfferMaterialsTitle = mapOf(
        Language.ENGLISH to "High-Quality Materials",
        Language.SPANISH to "Materiales de alta calidad"
    )
    val homeOfferMaterialsDesc = mapOf(
        Language.ENGLISH to "We use only premium paints and supplies for a finish that lasts.",
        Language.SPANISH to "Usamos solo pinturas y suministros de primera calidad para un acabado duradero."
    )

    val homeOfferServiceTitle = mapOf(
        Language.ENGLISH to "Professional Service",
        Language.SPANISH to "Servicio profesional"
    )
    val homeOfferServiceDesc = mapOf(
        Language.ENGLISH to "Skilled, reliable painters who show up on time and respect your space.",
        Language.SPANISH to "Pintores calificados y confiables que llegan a tiempo y respetan tu espacio."
    )

    val homeOfferEstimatesTitle = mapOf(
        Language.ENGLISH to "Free Estimates",
        Language.SPANISH to "Cotizaciones gratuitas"
    )
    val homeOfferEstimatesDesc = mapOf(
        Language.ENGLISH to "No-obligation quotes tailored to your project and budget.",
        Language.SPANISH to "Cotizaciones sin compromiso adaptadas a tu proyecto y presupuesto."
    )

    val homeOfferInsuredTitle = mapOf(
        Language.ENGLISH to "Fully Insured",
        Language.SPANISH to "Totalmente asegurado"
    )
    val homeOfferInsuredDesc = mapOf(
        Language.ENGLISH to "Complete peace of mind — we're fully licensed and insured.",
        Language.SPANISH to "Tranquilidad total: estamos totalmente autorizados y asegurados."
    )

    // Carousel
    val carousel1Title = mapOf(
        Language.ENGLISH to "Professional Interior Painting",
        Language.SPANISH to "Pintura Interior Profesional"
    )
    val carousel1Subtitle = mapOf(
        Language.ENGLISH to "Transform your living spaces with high-quality finishes.",
        Language.SPANISH to "Transforma tus espacios con acabados de alta calidad."
    )

    val carousel2Title = mapOf(
        Language.ENGLISH to "Expert Exterior Painting",
        Language.SPANISH to "Pintura Exterior Experta"
    )
    val carousel2Subtitle = mapOf(
        Language.ENGLISH to "Protect and beautify your home's exterior from the elements.",
        Language.SPANISH to "Protege y embellece el exterior de tu hogar contra los elementos."
    )

    val carousel3Title = mapOf(
        Language.ENGLISH to "Commercial Painting Services",
        Language.SPANISH to "Servicios de Pintura Comercial"
    )
    val carousel3Subtitle = mapOf(
        Language.ENGLISH to "Giving your business a fresh, professional look.",
        Language.SPANISH to "Dale a tu negocio un aspecto fresco y profesional."
    )

    val carousel4Title = mapOf(
        Language.ENGLISH to "Attention to Detail",
        Language.SPANISH to "Atención al Detalle"
    )
    val carousel4Subtitle = mapOf(
        Language.ENGLISH to "Quality craftsmanship in every brushstroke.",
        Language.SPANISH to "Artesanía de calidad en cada pincelada."
    )

    val carouselExplore = mapOf(
        Language.ENGLISH to "Explore Services",
        Language.SPANISH to "Explorar Servicios"
    )

    // Footer
    val footerOffice = mapOf(
        Language.ENGLISH to "Our Office",
        Language.SPANISH to "Nuestra Oficina"
    )
    val footerQuickLinks = mapOf(
        Language.ENGLISH to "Quick Links",
        Language.SPANISH to "Enlaces Rápidos"
    )
    val footerFollowUs = mapOf(
        Language.ENGLISH to "Follow Us",
        Language.SPANISH to "Síguenos"
    )
    val footerContactUs = mapOf(
        Language.ENGLISH to "Contact Us",
        Language.SPANISH to "Contáctanos"
    )
}
